export default "__VITE_ASSET__af4353b6__"